import "./App.css";

import MatchUtils from "./utils/MatchUtils";
import { useGlobalContext } from "./context";
import { useLocation } from "react-router-dom";

import Widget1vs1 from "./components/Widget1vs1";
import Loading from "./components/Loading";
import WidgetTG from "./components/WidgetTG";
import InstallInstructions from "./components/InstallInstructions";
import Home from "./components/Home";
import NewTemplate from "./components/NewTemplate";

function App() {
  const search = useLocation().search;
  const profileId = new URLSearchParams(search).get("profileId");

  const NUM_TEMPLATES = 2;
  var templateId = new URLSearchParams(search).get("template");
  templateId = !templateId ? "1" : templateId; // By default templateId=1 ()

  const installInstructions = new URLSearchParams(search).get("installation");

  const {
    loading,
    loadingHistoryHost,
    loadingHistoryGuest,
    setHostProfileId,
    hostLastMatch,
    hostMatchesHistory,
  } = useGlobalContext();

  if (templateId > NUM_TEMPLATES) {
    return <NewTemplate />;
  }

  if (installInstructions) {
    return <InstallInstructions />;
  }

  if (!profileId) {
    return <Home />;
  }

  // if (!isAlphaPlayer) {
  //   return <Help />;
  // }

  setHostProfileId(profileId);

  if (loading || loadingHistoryHost || loadingHistoryGuest) {
    return <Loading />;
  }

  return (
    <div className="App">
      {templateId === "1" ? (
        <div className="widget-background"></div>
      ) : (
        <div
          className="widget-background"
          style={{ backgroundColor: "#272c3400" }}
        ></div>
      )}
      {MatchUtils.getMatchType(hostLastMatch, hostMatchesHistory) ===
      MatchUtils.GAME_1VS1 ? (
        <Widget1vs1 showExtendedInfo={templateId === "1"} />
      ) : (
        <WidgetTG />
      )}
    </div>
  );
}

export default App;
